import { render, staticRenderFns } from "./FeatureForm.vue?vue&type=template&id=a00c55ba&"
import script from "./FeatureForm.vue?vue&type=script&lang=js&"
export * from "./FeatureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports